import { Direction } from '../types';

/**
 * Direction vectors for checking lines
 * Each direction checks in both positive and negative directions
 */
export const DIRECTIONS: Direction[] = [
  { rowDelta: 0, colDelta: 1 }, // Horizontal
  { rowDelta: 1, colDelta: 0 }, // Vertical
  { rowDelta: 1, colDelta: 1 }, // Diagonal (top-left to bottom-right)
  { rowDelta: 1, colDelta: -1 }, // Diagonal (top-right to bottom-left)
];

/**
 * Gets the opposite direction
 */
export function getOppositeDirection(direction: Direction): Direction {
  return {
    rowDelta: -direction.rowDelta,
    colDelta: -direction.colDelta,
  };
}

/**
 * Direction names for debugging
 */
export const DIRECTION_NAMES = [
  'Horizontal',
  'Vertical',
  'Diagonal \\',
  'Diagonal /',
];
